import { render, staticRenderFns } from "./object-card-rtsp.vue?vue&type=template&id=52076c25"
import script from "./object-card-rtsp.vue?vue&type=script&lang=js"
export * from "./object-card-rtsp.vue?vue&type=script&lang=js"
import style0 from "./object-card-rtsp.vue?vue&type=style&index=0&id=52076c25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports